import dayjs from 'dayjs';
import { V2EnergyConsumptionPlanValveStatusChangeLogPostResponse } from '@maxtropy/device-customer-apis-v2';
import { GasScheduleApiRow, SwitchRecordItem, ValveStatus } from './types';

export const valveStatusTextMap: Record<ValveStatus, string> = {
  [ValveStatus.Open]: '开',
  [ValveStatus.Close]: '关',
  [ValveStatus.Offline]: '离线',
};

export const valveStatusTagColorMap: Record<ValveStatus, string> = {
  [ValveStatus.Open]: 'success',
  [ValveStatus.Close]: 'error',
  [ValveStatus.Offline]: 'warning',
};

export function getHighlightCellClass(
  gasScheduleRow: GasScheduleApiRow,
  styles: { cellDanger: string; cellWarning: string }
) {
  if (!gasScheduleRow.isValveStatusAbnormal) {
    return '';
  }

  if (gasScheduleRow.inUseTime) return styles.cellDanger;
  if (gasScheduleRow.inUseTime === false) return styles.cellWarning;
  return '';
}

export function buildValveStatusLogRecords(
  logList: V2EnergyConsumptionPlanValveStatusChangeLogPostResponse['list']
): SwitchRecordItem[] {
  return (logList ?? []).map(logItem => ({
    id: logItem.id,
    operatedAt: logItem.operateTime ? dayjs(logItem.operateTime).format('YYYY-MM-DD HH:mm:ss') : '--',
    type: logItem.operateType === 2 ? 'automatic' : 'manual',
    beforeStatus: logItem.beforeStatus,
    afterStatus: logItem.afterStatus,
    operator: logItem.operateUser,
  }));
}
// 格式化时间显示
export const formatTimeRange = (baseTime: string, startTime?: string | number, endTime?: string | number) => {
  if (!startTime || !endTime) return '--';
  const base = dayjs(baseTime);
  const start = dayjs(startTime);
  const end = dayjs(endTime);

  // 判断开始时间是否为次日
  const isStartNextDay = start.isAfter(base, 'day');
  // 判断结束时间是否为次日
  const isEndNextDay = end.isAfter(base, 'day');

  const startFormatted = isStartNextDay ? `次日${start.format('HH:mm')}` : start.format('HH:mm');
  const endFormatted = isEndNextDay ? `次日${end.format('HH:mm')}` : end.format('HH:mm');

  return `${startFormatted}~${endFormatted}`;
};
